import { ChangePasswordComponent } from './change-password/change-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { NewsDetailsComponent } from './news-details/news-details.component';
import { SurveyComponent } from './survey/survey.component';
import { TimePickerComponent } from './time-picker/time-picker.component';
import { VersionCheckerComponent } from './version-checker/version-checker.component';

export const MODALS = [
  ChangePasswordComponent,
  ForgotPasswordComponent,
  NewsDetailsComponent,
  SurveyComponent,
  TimePickerComponent,
  VersionCheckerComponent
];
